import { CpMiniAuthInfoChannels } from '@bcf-vanilla-ts-v1-logic-worker-auth/bloc/mini-auth-info/cp-mini-auth-info-channels';
import { withLatestFromWaitable } from '@bcf-vanilla-ts-v1-shared/misc/custom-rx-operators/with-latest-from-waitable';
import {
  BcfRedirectBackSnapshot,
  provideBcfRedirectBackSnapshot
} from '@bcf2-shared-pkg-v1/ui/shared/bcf-router/bcf-redirect-back-snapshot';
import { UnsubscribableWithWorkerBlocForService } from '@bcflit-platforms/platform-worker/browser/unsubscribable-with-worker-bloc-for-service';
import {
  ModalNavigatorService,
  provideModalNavigatorService
} from '@bcflit-v1-ui-modals-shared/modal-navigator.service';
import { ActivatedUrl, provideActivatedUrl } from '@tmf-shared-platform/activated-url/activated-url';
import {
  provideRouterNavigatorService,
  RouterNavigatorService
} from '@tmf-shared-platform/router/router-navigator.service';
import { homeRoutePath } from '@tmf-ui-routes/paths/home.route-path';
import { userSettingsRoutePath } from '@tmf-ui-routes/paths/user-settings.route-path';
import { ReactiveControllerHost } from 'lit';
import { combineLatest, first, map } from 'rxjs';

export class UserPanelAuthGuardService extends UnsubscribableWithWorkerBlocForService<CpMiniAuthInfoChannels> {
  private _initialized: boolean = false;

  constructor(
    protected override _host: ReactiveControllerHost,
    private _routerNavigatorService: RouterNavigatorService,
    private _modalNavigatorService: ModalNavigatorService,
    private _bcfRedirectBackSnapshot: BcfRedirectBackSnapshot,
    private _activatedUrl: ActivatedUrl
  ) {
    super(_host);
    this._initWorkerBloc('cp-mini-auth-info');
  }

  public override init(): void {
    if (this._initialized) {
      return;
    }
    this._initialized = true;

    this._sub = combineLatest([this._subTo('isCheckedAndLoggedIn'), this._activatedUrl.url$])
      .pipe(
        first(([isLoggedIn, url]: [boolean, string]) => !isLoggedIn && url.includes(userSettingsRoutePath())),
        map(() => undefined),
        withLatestFromWaitable(this._bcfRedirectBackSnapshot.serializeSnapshot())
      )
      .subscribe(([_, snapshot]: [undefined, string]) => {
        this._routerNavigatorService.navigateTo(homeRoutePath());
        setTimeout(() => {
          this._modalNavigatorService.navigate('login', ['redirect-back', snapshot]);
        }, 250);
      });
  }
}
export function provideUserPanelAuthGuardService(host: ReactiveControllerHost): UserPanelAuthGuardService {
  return new UserPanelAuthGuardService(
    host,
    provideRouterNavigatorService(),
    provideModalNavigatorService(),
    provideBcfRedirectBackSnapshot(),
    provideActivatedUrl()
  );
}
